import About from "./componentes/About";
import Contact from "./componentes/Contact";
import Home from "./componentes/Home";
import Navbar from "./componentes/Navbar";
import Skills from "./componentes/Skills";
import Work from "./componentes/Work";

function App() {
  return (
    <div>
     <Navbar />
     <Home />
     <About />
     <Skills />
     <Work />
     <Contact />
    </div>
  );
}

export default App;
